import React from 'react';
import cx from '../utils/cx';
import ui from '../styles/primitives.module.css';
import styles from './FeatureCard.module.css';

// Photo card used by "Invest with DS360" and "Investment insights".
const FeatureCard = ({ image, tag, title, text, href, linkLabel, external = false, surface = 'glass' }) => (
  <article className={cx(styles.card, ui[surface])} data-tilt="" data-reveal="">
    <div className={styles.photo}>
      <img src={image} alt="" loading="lazy" />
    </div>
    <span className={ui.tag}>{tag}</span>
    <h3>{title}</h3>
    <p>{text}</p>
    <a
      className={styles.more}
      href={href}
      {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
    >
      {linkLabel} <span aria-hidden="true">→</span>
      {external && <span className={ui.srOnly}> (opens in a new tab)</span>}
    </a>
  </article>
);

export default FeatureCard;
